import { RootState } from "../reducers/root.reducer";

export const getIsEnterMode = (state: RootState) => state.repEnterMode.customerHp;
export const getEnterModeName = (state: RootState) => state.repEnterMode.customerName;
